import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-gray-900 bg-opacity-75" }, null, -1)
const _hoisted_3 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_4 = { class: "flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0" }
const _hoisted_5 = { class: "relative w-full text-left transition-all transform bg-white rounded shadow sm:my-8 sm:w-full sm:max-w-lg" }
const _hoisted_6 = { class: "bg-white" }
const _hoisted_7 = { class: "flex items-center justify-between border-b border-gray-400" }
const _hoisted_8 = { class: "w-full px-4 py-4 text-left" }
const _hoisted_9 = {
  class: "text-lg font-medium leading-6 text-gray-900",
  id: "modal-title"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-x-lg",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onSubmit"]
const _hoisted_13 = { class: "relative" }
const _hoisted_14 = { class: "relative mt-2" }
const _hoisted_15 = { class: "mt-4 text-sm font-medium" }
const _hoisted_16 = {
  key: 0,
  class: "absolute z-20 w-full mt-2 overflow-y-auto bg-white rounded shadow max-h-64 h-fit overflow-clip"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "text-black lowercase truncate" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "flex justify-center px-4 py-3 bg-gray-50" }

import { PropType, watch, ref } from "vue";

import DefaultButton from "../DefaultButton.vue";

import api from "@/api/api";
import { Event } from "@/types";
import { useGlobalStore } from "@/store";
import { useI18n } from "vue-i18n";
import { debounce } from "@/utils/debounce";


export default /*#__PURE__*/_defineComponent({
  __name: 'ManualBookingModal',
  props: {
  isOpen: {
    type: Boolean,
    required: true,
  },
  event: {
    type: Object as PropType<Event>,
    required: true,
  },
},
  emits: ["close", "create"],
  setup(__props, { emit: emits }) {

const props = __props;

const { t: $t } = useI18n();
const globalStore = useGlobalStore();




const isModalOpen = ref(false);
const query = ref("");

const results = ref([] as Array<{ id: string; email: string; first_name: string; last_name: string }>);
const user = ref({ id: "", first_name: "", last_name: "", email: "" } as {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
});

function setUser(u: { id: string; email: string; first_name: string; last_name: string }) {
  user.value = u;
  isModalOpen.value = false;
  query.value = "";
}

async function createManualBooking() {
  try {
    if (!user.value?.first_name || !user.value?.last_name || !user.value?.email) {
      globalStore.toast("ERROR", "Please ensure the user exists and try again.");
      return;
    }

    const validCheckRequest = (await api.users.checkValidDelegate(props.event.id, user.value)).data;

    if (!validCheckRequest) {
      return;
    }

    if (!validCheckRequest.valid) {
      globalStore.toast("ERROR", validCheckRequest.error!);
      return;
    }

    const response = await api.bookings.createManualBooking({ user_id: user.value!.id, event_id: props.event.id });

    globalStore.toast("SUCCESS", `Added user to Event - Booking ID #${response.data.booking.id}`);
    emits("create");
    emits("close");
  } catch (error) {
    console.log(error);
  }
}

function close() {
  emits("close");
}

const debouncedFetchResults = debounce(async () => {
  if (query.value === "") {
    results.value = [];
    return;
  }
  results.value = (await api.users.searchUsers(query.value, "email")).data.users;
}, 300);

function search() {
  isModalOpen.value = true;
  debouncedFetchResults();
}

watch(
  () => props.isOpen,
  () => {
    if (!props.isOpen) {
      query.value = "";
      user.value = {
        id: "",
        first_name: "",
        last_name: "",
        email: "",
      };
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (props.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h3", _hoisted_9, _toDisplayString(_unref($t)("create-manual-booking")), 1)
                  ]),
                  _createElementVNode("div", { class: "py-4 pl-2 pr-4" }, [
                    _createElementVNode("button", { onClick: close }, _hoisted_11)
                  ])
                ]),
                _createElementVNode("form", {
                  class: "px-4 pb-8 mt-2 border-b border-gray-400",
                  onSubmit: _withModifiers(createManualBooking, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("label", _hoisted_15, _toDisplayString(_unref($t)("please-select")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
                        onInput: search,
                        id: "user",
                        class: "w-full h-10 mt-2 text-gray-900 border border-gray-600 rounded hover:cursor-pointer",
                        placeholder: "Search users by email..."
                      }, null, 544), [
                        [_vModelText, query.value]
                      ])
                    ]),
                    (isModalOpen.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, (user) => {
                              return (_openBlock(), _createElementBlock("li", {
                                class: "w-full px-4 py-2 capitalize hover:bg-blue-500 hover:text-white hover:cursor-pointer whitespace-nowrap",
                                onClick: ($event: any) => (setUser(user)),
                                key: user.id
                              }, [
                                _createTextVNode(_toDisplayString(user.first_name) + " " + _toDisplayString(user.last_name), 1),
                                _createElementVNode("span", _hoisted_18, " - " + _toDisplayString(user.email), 1)
                              ], 8, _hoisted_17))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (user.value.first_name)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                        _createTextVNode(" Selected "),
                        _createElementVNode("span", null, _toDisplayString(user.value.first_name) + " " + _toDisplayString(user.value.last_name) + " (" + _toDisplayString(user.value.email) + ")", 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(DefaultButton, {
                      type: "primary",
                      "is-form-submit": true,
                      disabled: false
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($t)("add-user-to-course")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ], 40, _hoisted_12)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})